/**
 * All user-related global states are initialized here with pre-authentication default values.
 */

import { atom } from "recoil";
import { IUser, UserGroup } from "../../config/types/user";
import { IGetJobsPayload } from "queries/Jobs";
import { datePostedFilter, defaultPreferenceScore } from "config/Consts";
export interface ISavedJobsPayload extends IGetJobsPayload {}

export const userDefaults: IUser = {
  id: null,
  email: null,
  name: null,
  userGroup: UserGroup.T0,
};

export const userState = atom({
  key: "userState",
  default: userDefaults,
});

export const surveySavingAlertState = atom({
  key: "surveyAlertState",
  default: {
    isOpen: false,
  },
});

export const surveyCompletedState = atom({
  key: "surveyCompleteState",
  default: false,
});

export const defaultJobPayload: IGetJobsPayload = {
  page: 1,
  perPage: 10,
  enabled: false,
  postedDate: datePostedFilter[2],
  distance: undefined,
  preferenceScore: defaultPreferenceScore,
};

export const jobPayloadState = atom({
  key: "jobPayload",
  default: defaultJobPayload,
});

export const selectedSortByState = atom({
  key: "selectedSortByState",
  default: [""],
});

export const savedJobsSortByState = atom<string[]>({
  key: "savedJobsSortByState",
  default: [],
});

export const savedJobs = atom<any[]>({
  key: "savedJobs",
  default: [],
});

export const defaultSavedJobPayload: ISavedJobsPayload = {
  page: 1,
  perPage: 12,
  enabled: true,
};

export const savedJobPayloadState = atom({
  key: "savedJobPayload",
  default: defaultSavedJobPayload,
});

export const setUpdatingZip = atom({
  key: "updatingZip",
  default: false,
});

export const jobSearchPageState = atom({
  key: "jobSearchPageState",
  default: {
    jobIdx: -1,
    appliedJobIdx: -1,
    savedJobIdx: -1,
  },
});
